<p *ngIf="item.link_location!=='modal'">
    <a (click)="openLink($event)" [href]="_rel_url" [ngClass]="{'no-underline':item.link_type==='components' &&!item.use_underline,
     'underline-link':item.use_underline
  }"><ng-container *ngTemplateOutlet="linkcontent"></ng-container></a>
</p>
<p *ngIf="item.link_location==='modal'" class="open-view-in-modal">
    <a (click)="openViewLink($event, info, 'read', item.link_target)" [href]="_rel_url"  [ngClass]="{'no-underline':item.link_type==='components'&&!item.use_underline,
    'underline-link':item.use_underline}"><ng-container *ngTemplateOutlet="linkcontent"></ng-container></a>
</p>

<ng-template #linkcontent>
  <span *ngIf="item.link_type!='components'" [innerHTML]="item.value ||item.translation_key|| item.text| translation|translationFromString | transformText :item?.text_transform"></span>
  <div *ngIf="item.link_type=='components'">
    <app-rendered [childview]="item.childview || childview" [paramprefix]="item.paramprefix" [info]="info" *ngFor="let it of item.content" [item]="it" [data]="data" [arr]="item.content"></app-rendered>
  </div>
</ng-template>
